// extracted by mini-css-extract-plugin
export default {"mobileMenuButton":"MobileMenu_mobileMenuButton__3ilQw"};